// https://medium.com/inato/expressive-error-handling-in-typescript-and-benefits-for-domain-driven-design-70726e061c86
// TODO: Moving to above would be great
import { getApolloErrorCodes } from 'v2/core/repository/edge-server/error';
import ErrorCode from 'v2/core/errors/codes';
import { ErrorResponse } from '@apollo/client/link/error';

const AndOfErrors = (errors: Array<Error | undefined>): Error | undefined => {
  return errors.find((e) => e);
};

const isErrorCode = (
  error: Error | ErrorResponse | undefined,
  code: ErrorCode,
): boolean => {
  return getApolloErrorCodes(error)?.includes(code) ?? false;
};

const check404Error = (error: Error) => {
  return isErrorCode(error, ErrorCode.RecordNotFound);
};

export { AndOfErrors, isErrorCode, check404Error };
